import { render, staticRenderFns } from "./SocialMediaReportList.vue?vue&type=template&id=6f145c90"
import script from "./SocialMediaReportList.vue?vue&type=script&lang=js"
export * from "./SocialMediaReportList.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaReportList.vue?vue&type=style&index=0&id=6f145c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports